import * as Config from '../../../config';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './Browser.css';

import { setBrowserOptimal, setBannerBrowser } from '../../../actions';

function BannerNoChrome() {
  const [browser, setBrowser] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    const user_agent = navigator.userAgent.toLowerCase();
    if (user_agent.indexOf('firefox') > -1 || (user_agent.indexOf('safari') > -1 && user_agent.indexOf('chrome') === -1)) { 
      setBrowser(false);
      dispatch(setBrowserOptimal(false));
      dispatch(setBannerBrowser(true));
    }
  }, [dispatch])

  useEffect(() => {
    const el = document.getElementById('alpha2');
    if (el) {
      el.style.top = (browser === false) ? `${Config.BANNER_BROWSER_HEIGHT}px` : '0px';
    }
  }, [browser])

  const close = () => {
    setBrowser(true);
    dispatch(setBannerBrowser(false));
  } 

  return !browser ? (
    <div className={'flexRow align space-between banner-no-chrome'}>
      <span>Google Chrome or Microsoft Edge browser recommended for optimal performance and MIDI functionality.</span>
      <div onClick={close} className="banner-no-chrome-close">
        <span className='banner-no-chrome-button-close'>Close</span>
      </div>
    </div>
  ) : null;
}

export default BannerNoChrome;
